export const IdentityStatusMessages: Record<string, string> = {
  "ins_check_ok": "Les informations d'identité du patient ont été validées avec succès.",
  "ins_check_ko": "La validation de l'identité a échoué ! Les informations d'identité du patient n’ont pas pu être validées.",
  "00": "Les informations d'identité du patient ont été validées et récupérées depuis le service INSi. (Code retour INSI: 00 - Une identité trouvée)",
  "01": "Aucune identité trouvée dans le service INSi. (Code retour INSI: 01 - Aucune identité trouvée)",
  "02": "Plusieurs identités trouvées dans le service INSi. (Code retour INSI: 02 - Plusieurs identités trouvées)",
};
